import { takeEvery, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
    FETCH_CURRENT_USER_INFO,
    FETCH_CURRENT_USER_INFO_FETCHING,
    FETCH_CURRENT_USER_INFO_SUCCESS,
    FETCH_CURRENT_USER_INFO_FAIL
} from 'actions/ActionTypes';

// Workers
export function* fetchCurrentUserInfoSaga(action = {}) {
    try {
        yield put({
            type: FETCH_CURRENT_USER_INFO_FETCHING
        });

        const response = yield call(axios.get, `/currentuser-service/user/info`, { baseURL: '/modern' });

        yield put({
            type: FETCH_CURRENT_USER_INFO_SUCCESS,
            userInfo: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_CURRENT_USER_INFO_FAIL
        });
    }
}

// Watchers
export const currentUserInfoSagas = [takeEvery(FETCH_CURRENT_USER_INFO, fetchCurrentUserInfoSaga)];
